module.exports = __webpack_public_path__ + "img/fig05.3e006955.jpg";